/**
 * Русификация ролей/прав персонала (§7.3, §7.4 дизайн manager v3).
 *
 * Дизайн требует человеческие лейблы ролей («Горничная», «Сотрудник кухни»…),
 * а internal-ключ (staff:housekeeping) показывается только в подсказке —
 * это для интеграции с RBAC. См. мокап 7.3:
 *   «отображается человеческое название: Горничная, Менеджер по номерам,
 *    Сотрудник кухни, Метрдотель, Сомелье, Concierge … Internal-ключ виден
 *    при наведении».
 */

/** Человеческий RU-лейбл по internal-ключу роли. */
export const ROLE_KEY_LABEL: Readonly<Record<string, string>> = {
  "staff:housekeeping": "Горничная",
  "staff:housekeeping_lead": "Старшая горничная",
  "staff:kitchen": "Сотрудник кухни",
  "staff:bar": "Бармен",
  "staff:spa": "Сотрудник SPA",
  "staff:reception": "Администратор стойки",
  "staff:repair": "Техобслуживание",
  "staff:concierge": "Concierge",
  housekeeper: "Горничная",
  restaurant: "Сотрудник кухни / бара",
  front_desk: "Администратор стойки",
  maintenance: "Техобслуживание",
  staff: "Сотрудник",
  hotel_manager: "Менеджер отеля",
  tenant_owner: "Владелец",
};

/** Лейбл роли: человеческое имя, иначе display_name, иначе ключ. */
export function roleKeyLabel(key: string, displayName?: string): string {
  if (ROLE_KEY_LABEL[key]) return ROLE_KEY_LABEL[key]!;
  if (displayName != null && displayName.trim() !== "") return displayName.trim();
  return key;
}

/** Каталог прав (permissions) с RU-описанием — для формы роли §7.4. */
export interface PermissionDef {
  key: string;
  label: string;
}

export const PERMISSION_CATALOG: ReadonlyArray<PermissionDef> = [
  { key: "requests.view", label: "Просмотр заявок" },
  { key: "requests.handle", label: "Обработка заявок (взять/завершить)" },
  { key: "requests.assign", label: "Назначение заявок на сотрудников" },
  { key: "requests.escalate", label: "Эскалация заявок" },
  { key: "rooms.view", label: "Просмотр номеров" },
  { key: "rooms.manage", label: "Управление номерами" },
  { key: "stays.view", label: "Просмотр проживаний" },
  { key: "stays.checkin", label: "Заезд / выезд гостей" },
  { key: "menu.manage", label: "Управление меню F&B" },
  { key: "staff.view", label: "Просмотр персонала" },
  { key: "staff.manage", label: "Управление персоналом" },
  { key: "reviews.moderate", label: "Модерация отзывов" },
];

/** Перевод набора permissions в краткую RU-сводку «что может». */
export function permissionsSummary(perms: string[]): string {
  if (perms.length === 0) return "—";
  const labels = perms.map((p) => {
    const def = PERMISSION_CATALOG.find((d) => d.key === p);
    return def ? def.label : p;
  });
  return labels.join(" · ");
}
